export default function registerShowOnInteractiveDir($) {
  $.registerDirective("show-on-interactive", {
    bind() {
      const { el } = this;
      const events = "scroll mousedown touchstart mousemove";
      function interactiveHandler(e) {
        el.removeClass("lqip-hidden").addClass("interactived");
        events.split(" ").forEach(function (eventName) {
          $(window).off(eventName, interactiveHandler);
        });
      }
      $(window).on(events, interactiveHandler);
    },
    update(value) {
      const { el } = this;
      if (value === "mobile") {
        if ($.env.isMobile) {
          el.addClass("lqip-hidden");
        }
      } else {
        el.addClass("lqip-hidden");
      }
    },
  });
}
